import { t } from "@/i18n-js/instance";
import { Typography } from "@circle-react-uikit/Typography";
import { FeatureItem } from "./FeatureItem";

export const AiActionsSection = () => (
  <div className="mb-4">
    <div className="mb-2">
      <Typography.LabelSm weight="bold">
        {t("settings.ai_actions.modal.ai_actions.title")}
      </Typography.LabelSm>
    </div>
    <div className="space-y-3">
      <FeatureItem
        description={t(
          "settings.ai_actions.modal.ai_actions.deploy_agents_desc",
        )}
      />
      <FeatureItem
        description={t(
          "settings.ai_actions.modal.ai_actions.train_agents_desc",
        )}
      />
    </div>
  </div>
);
